import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';
import styles from './Winner.module.css';

import posterDefault from '../../assets/images/posterWinners.png';
import bgDefaultVideo from '../../assets/video/bgWinners.mp4';

export const Winner = ({ winnerFontSize, winners, bgVideo, bgPoster }) => {
  const isOneWinner = winners.length <= 1;

  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel];
  };

  return (
    <div className={`${styles.container}`}>
      <div className={styles.title}>
        {isOneWinner ? 'победитель!' : 'победители!'}
      </div>
      <div className={`${styles.winnersBlock}`}>
        {winners.length !== 0 &&
          winners.slice(0, 3).map((el, i) => {
            return (
              <div
                className={styles.winnersItem}
                key={el.id}
                style={{ '--delay': `${i * 0.5 + 1.5}s` }}
              >
                <div className={styles.avatarAndName}>
                  <div className={styles.avatarBlock}>
                    <img
                      className={styles.avatar}
                      src={
                        (el.message.image !== '1' && el.message.image) ||
                        iconsSources[el.message.channel]
                      }
                      onError={(e) => errorHandler(e, el.message.channel)}
                      alt="avatar"
                    />
                  </div>
                  <div
                    className={styles.author}
                    style={{ fontSize: `${winnerFontSize}rem` }}
                  >
                    {el.message.author || hideNumber(el.message.senderNumber)}
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.videoBg}
        poster={bgVideo === '1' ? posterDefault : bgPoster}
      >
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/mp4"
        ></source>
      </video>
    </div>
  );
};
